import * as React from "react";
import { Route, Navigate } from "react-router-dom";
import { SwitchWith404 } from "Config/Router";
import { EmailListPage } from "./Pages/EmailListPage";
import { emailUnreadStore } from "./Stores/EmailUnreadStore";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { EmailSearchResultsPage } from "./Pages/EmailSearchResultsPage";
import { groupListStore } from "../Groups/Stores/GroupsStore";
import { TopicInbox } from "./Pages/TopicInbox";

export enum MAIL_LINK {
  INBOX = "inbox",
  INBOX_PROJECT = "projectInbox",
  SENT = "sent",
  SENT_PROJECT = "projectSent",
  ARCHIVED = "archived",
  LINKED = "linked",
  SEARCH_RESULTS = "searchResults",
  TOPIC_INBOX = "topic-inbox",
  ARCHIVE_PROJECT = "projectArchived",
  DRAFT = "drafts",
}

// used to have the only fetch interval between fetching unread messages and email lists
export const FETCH_INTERVAL = 120000;

const InboxProject = () => <EmailListPage emailType="INBOX" accessLevel="project" />;
const Inbox = () => <EmailListPage emailType="INBOX" accessLevel="private" />;
const Sent = () => <EmailListPage emailType="SENT" accessLevel="private" />;
const SentProject = () => <EmailListPage emailType="SENT" accessLevel="project" />;
const Archived = () => <EmailListPage emailType="ARCHIVED" />;
const ArchivedProject = () => <EmailListPage emailType="ARCHIVED" accessLevel="project" />;
const Linked = () => <EmailListPage emailType="LINKED" />;
const Drafts = () => <EmailListPage emailType="DRAFT" />;

interface CommunicationProps extends WithTranslation {}

export const Communication = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<CommunicationProps, {}> {
    private unreadFetchInterval;
    componentDidMount() {
      (async () => {
        if (groupListStore.state === "RAW") {
          await groupListStore.fetch();
        }
        await emailUnreadStore.fetch();
      })();
      this.unreadFetchInterval = window.setInterval(() => emailUnreadStore.fetch(), FETCH_INTERVAL);
    }

    componentWillUnmount() {
      clearInterval(this.unreadFetchInterval);
    }

    render() {
      return (
        <SwitchWith404>
          <Route path="*" element={<Navigate to={`${MAIL_LINK.INBOX}`} replace />} />
          <Route path={`${MAIL_LINK.INBOX_PROJECT}/*`} element={<InboxProject />} />
          <Route path={`${MAIL_LINK.INBOX}/*`} element={<Inbox />} />
          <Route path={`${MAIL_LINK.SENT_PROJECT}/*`} element={<SentProject />} />
          <Route path={`${MAIL_LINK.SENT}/*`} element={<Sent />} />
          <Route path={`${MAIL_LINK.ARCHIVED}/*`} element={<Archived />} />
          <Route path={`${MAIL_LINK.ARCHIVE_PROJECT}/*`} element={<ArchivedProject />} />
          <Route path={`${MAIL_LINK.LINKED}/*`} element={<Linked />} />
          <Route path={`${MAIL_LINK.TOPIC_INBOX}/*`} element={<TopicInbox />} />
          <Route path={`${MAIL_LINK.SEARCH_RESULTS}/*`} element={<EmailSearchResultsPage />} />
          <Route path={`${MAIL_LINK.DRAFT}/*`} element={<Drafts />} />
        </SwitchWith404>
      );
    }
  }
);

export default Communication;
